import { Component, inject, input, output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MenuController } from '@ionic/angular';
import { AuthFormConfig } from 'src/app/models/auth.model';

@Component({
  selector: 'app-auth-form',
  templateUrl: './auth-form.component.html',
  styleUrls: ['./auth-form.component.scss'],
  standalone: false,
})
export class AuthFormComponent {
  /* Configuration object defining form fields and labels */
  config = input<AuthFormConfig>();

  /* Dynamic form model bound to input fields */
  model = input<any>();

  /* Controls password visibility state */
  showPassword = input<boolean>(false);

  /* Indicates whether field validation errors should be shown */
  fieldValidation = input<boolean>(false);

  /* Emits form submission event with NgForm reference */
  submitForm = output<NgForm>();

  /* Emits back navigation intent */
  backBtn = output<void>();

  /* Emits password visibility toggle intent */
  togglePassword = output<void>();

  /* Handles form submission */
  onSubmit(form: NgForm): void {
    this.submitForm.emit(form);
  }

  /* Emits back button action */
  emitBack(): void {
    this.backBtn.emit();
  }

  getUniqueValidations(validations: string[] | undefined) {
    return new Set(validations);
  }

}
